import { render, staticRenderFns } from "./book-edit.vue?vue&type=template&id=7146e513&"
import script from "./book-edit.vue?vue&type=script&lang=js&"
export * from "./book-edit.vue?vue&type=script&lang=js&"
import style0 from "./book-edit.vue?vue&type=style&index=0&id=7146e513&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports